export var DismissButtonLabel = "Dismiss";
